module.exports = __webpack_public_path__ + "static/media/spt.c1270eb9.png";